import { render, staticRenderFns } from "./AddItemModal.vue?vue&type=template&id=89aa402c&lang=pug&"
import script from "./AddItemModal.vue?vue&type=script&lang=ts&"
export * from "./AddItemModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddItemModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports